// Coverage defaults + client-side validation that mirrors the server guard.

export const ACSA_DEFAULTS = {
  l1_free_hours: "2",
  l1_percent: "100",
  l2_percent: "60",
  l2_cap: "1000",
  l3_percent: "60",
  l3_cap: "4000",
  billing_increment_min: "6",
};

export const DEFAULT_ROUND = {
  order: 1,
  l1_enabled: true,
  l2_enabled: true,
  l3_enabled: true,
};

const PERCENT_FIELDS = ["l1_percent", "l2_percent", "l3_percent"];
const NONNEG_FIELDS = ["l1_free_hours", "l2_cap", "l3_cap"];

/** Returns { field: message } for invalid coverage dials (empty object = valid). */
export function validateCoverage(profile) {
  const errors = {};
  PERCENT_FIELDS.forEach((k) => {
    const v = Number(profile[k]);
    if (profile[k] === "" || Number.isNaN(v) || v < 1 || v > 100) {
      errors[k] = "Must be 1–100";
    }
  });
  NONNEG_FIELDS.forEach((k) => {
    const v = Number(profile[k]);
    if (profile[k] === "" || Number.isNaN(v) || v < 0) {
      errors[k] = "Must be ≥ 0";
    }
  });
  return errors;
}

export function numericProfile(profile) {
  return {
    l1_free_hours: Number(profile.l1_free_hours),
    l1_percent: Number(profile.l1_percent),
    l2_percent: Number(profile.l2_percent),
    l2_cap: Number(profile.l2_cap),
    l3_percent: Number(profile.l3_percent),
    l3_cap: Number(profile.l3_cap),
    billing_increment_min: Number(profile.billing_increment_min || 6),
  };
}

export function profileFromMatter(m) {
  return {
    l1_free_hours: String(m.l1_free_hours ?? 2),
    l1_percent: String(m.l1_percent ?? 100),
    l2_percent: String(m.l2_percent ?? 60),
    l2_cap: String(m.l2_cap ?? 1000),
    l3_percent: String(m.l3_percent ?? 60),
    l3_cap: String(m.l3_cap ?? 4000),
    billing_increment_min: String(m.billing_increment_min ?? 6),
  };
}
